import './style.css';
import { Router } from './router/Router';
import { LandingPage } from './pages/LandingPage';
import { DiagramsApp } from './app/DiagramsApp';

const container = document.getElementById('app')!;
const router = new Router(container);

let currentPage: LandingPage | DiagramsApp | null = null;

router
  .route('/', () => {
    if (currentPage) currentPage.destroy();
    currentPage = new LandingPage(container, router);
    router.setCleanup(() => currentPage?.destroy());
  })
  .route('/new', () => {
    // For now, just render the editor directly
    // Phase 2: This will create a new diagram and redirect to /d/:id
    if (currentPage) currentPage.destroy();
    currentPage = new DiagramsApp(container, router);
    router.setCleanup(() => currentPage?.destroy());
  })
  .route('/d/:id', (params) => {
    // Phase 2: Load diagram by ID from backend
    if (currentPage) currentPage.destroy();
    currentPage = new DiagramsApp(container, router, params.id);
    router.setCleanup(() => currentPage?.destroy());
  })
  .start();
